import React from "react";
// import "./ExpensesMfTable.css";
import "../../GlobalCss/SPF/ExpensesMfTable.css";
import { useState, useEffect } from "react";
import {Form,Upload,Input,message,Popconfirm,Table,Typography,Button,Modal,Spin,Image,DatePicker,Tooltip,} from "antd";
import {SendOutlined,ReloadOutlined,CheckOutlined,CloseOutlined,UploadOutlined,DeleteOutlined,SearchOutlined,} from "@ant-design/icons";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import { BaseUrl, FormConfig } from "../../Repository/BaseRepository";
import moment from "moment";
import Cookies from "js-cookie";
import { GetActiveListLastUploadedDate } from "../../Repository/HealthInsuranceRepository";
import { getExpensesMfData, refreshExpensesData, downloadExpensesMSXL, updateExpensesMFRow } from "../../Repository/ExpenseModuleRepository";
import { title } from "process";
import JSZip from "jszip";





const ExpensesMfTable = () => {
  const [form] = Form.useForm();

  const [griddata, setGriddata] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [rowData, setRowData] = useState([]);
  const [searchRow, setSearchRow] = useState("");
  const [syncSpin, setSyncSpin] = useState(false);
  const isEditing = (record) => record.ID === editingKey;
  const [activeList, setActiveList] = useState([]);
  const [activitySpin, setActivitySpin] = useState(false);
  const [dateList, setDateList] = useState(null);
  const userLogin = Cookies.get("UserLogin");
  const [newFrom, setNewFrom] = useState("");
  const [newTo, setNewTo] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setTodate] = useState();

  const handleActivelistUpload = async (options) => {
    try {
      setActivitySpin(true);
      const { file, onSuccess, onError } = options;
      const updatedDeductionFile = { file, status: "uploading" };
     

      const zipFile = options.target.files[0];
      if(!zipFile)
        return
      const zip = new JSZip();

      const zipContent = await zip.loadAsync(zipFile);

       const formData = new FormData();

      await Promise.all(
        Object.keys(zipContent.files).map(async (relativePath) => {
        const entry = zipContent.files[relativePath];
        if(entry.dir)
          return
  
        const fileData = await entry.async("blob");
  
        formData.append("file", new File([fileData], relativePath));
      })
    );

      const response = await axios.post(
        `${BaseUrl}Expenses/UploadFileFuntionality`,
        formData,
        FormConfig
      );
      if (response.data && response.data.statusCode === 200) {
        //onSuccess(file);
        SuccessMessage("File uploaded successfully");
        updatedDeductionFile.status = "done";
        //setActiveList([updatedDeductionFile]);
        //setActivitySpin(false);
        //fetchData(); 
      } else {
        onError(file);
        ErrorMessage(response.data.message || "File upload failed");
        updatedDeductionFile.status = "error";
        setActiveList([updatedDeductionFile]);
        setActivitySpin(false);
      }
    } catch (error) {
      message.error(`File upload failed`);
      setActivitySpin(false);
    }
  };

  // const itemActiveListRender = (originNode, file) => {
  //   let statusColor;
  //   if (file.status === "done") {
  //     statusColor = "green";
  //   } else if (file.status === "error") {
  //     statusColor = "#f55451";
  //   }
  //   let fileExists = false;
  //   if (activeList.length > 0) {
  //     fileExists = true;
  //   }
  //   return (
  //     <>
  //       <div style={{ display: "flex", alignItems: "center", height: "auto" }}>
  //         <div
  //           style={{
  //             color: statusColor,
  //             width: "40%",
  //             height: "auto",
  //             display: "flex",
  //             justifyContent: "space-between",
  //             marginTop: "2px",
  //             marginLeft:"25px",
  //             borderRadius: "4px",
  //           }}
  //         >
  //           {fileExists ? activeList[0].file.name : null}
  //         </div>
  //         <DeleteOutlined
  //           style={{ marginTop: "2px" }}
  //           onClick={() => setActiveList([])}
  //         />
  //       </div>
  //     </>
  //   );
  // };
  useEffect(() => {
    callGriddata();
   
  }, []);
 

  // useEffect(() => {
  //   fetchData();
   
  // }, []);

  

  const fetchData = async () => {
    try {
      const response = await GetActiveListLastUploadedDate();
      console.log(response);
      if (response && response.payload) {
        const payloadObject = JSON.parse(response.payload);
        setDateList(payloadObject);
        console.log(payloadObject);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const callGriddata = async () => {
    try {
      setTableLoader(true);
      const res = await getExpensesMfData();
      if (res !== null && res.length > 0) {
        setGriddata(res);
      }
      setTableLoader(false);
    } catch {
      ErrorMessage("Cannot able to get data");
    }
  };
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const filterProps = () => ({
    filteredValue: [searchRow],
    onFilter: (value, record) => {
      return (
        String(record.Client_Name)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.Portal_Name)
          .toLowerCase()
          .includes(String(value).toLowerCase())
      );
    },
  });
  const columns = [
    {
      title: "Name",
      key: "Name",
      dataIndex : "Name",
      width: 150,
      editable : true,
      ellipsis: true,
      ...filterProps(),
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "Weekend Date",
      key: "Weekend_Date",
      dataIndex: "Weekend_Date",
      width: 200,
      editable: true,
      ellipsis: true,
    },
    {
      title: "Client Name",
      key: "Client_Name",
      dataIndex: "Client_Name",
      width: 150,
      editable: true,
      ellipsis: true,
      ...filterProps(),
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "Unique EXP ID",
      key : "UniqueExpId",
      dataIndex : "UniqueExpId",
      width : 150,
      editable : true,
      ellipsis: true,
      ...filterProps(),
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title : "Amount",
      key : "Amount",
      dataIndex : "Amount",
      width : 100,
      editable : true,
      ellipsis: true,
    },
    {
      title: "Status",
      key: "Approved_Status",
      dataIndex: "Approved_Status",
      width: 150,
      editable: true,
      ellipsis: true,
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "File No",
      key: "FileNo",
      dataIndex: "FileNo",
      width: 150,
      editable: true,
      ellipsis: true,
    },
    {
      title: "Other EXP ID",
      key: "OtherExpId",
      dataIndex: "OtherExpId",
      width: 150,
      editable: true,
      ellipsis: true,
    },
    {
      title: "Processed Date",
      key: "ProcessedDate",
      dataIndex: "ProcessedDate",
      width: 150,
      editable: true,
      ellipsis: true,
    },
    {
      title: "GL Amount#",
      key: "GLAmount",
      dataIndex: "GLAmount",
      width: 150,
      editable: true,
      ellipsis: true,
    },
    {
      title: "GL Name",
      key: "GLName",
      dataIndex: "GLName",
      width: 150,
      editable: true,
      ellipsis: true,
    },
    // {
    //   title: "Portal Name",
    //   key: "Portal_Name",
    //   dataIndex: "Portal_Name",
    //   width: 150,
    //   editable: true,
    //   ellipsis: true,
    //   render: (text, record, index) => (
    //     <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
    //   ),
    // },
   
    {
      title: "ACTION",
      dataIndex: "action",
      fixed: "right",
      width: 100,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Popconfirm
              title="Sure to save?"
              onConfirm={() => editTableRowData(record)}
              onCancel={cancel}
            >
              <Typography.Link
                style={{
                  marginRight: 8,
                }}
              >
                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
              </Typography.Link>
            </Popconfirm>
            <Typography.Link onClick={() => cancel()}>
              <CloseOutlined style={{ color: "red" }} />
            </Typography.Link>
          </span>
        ) : (
          <div>
            <Typography.Link
              onClick={() => edit(record)}
              disabled={editingKey !== ""}
            >
              <Image
                src="/Images/editicon.svg"
                style={{
                  border: "none",
                  width: "100% ",
                  marginRight: 5,
                }}
                showPreviewIcon={false}
                preview={false}
              />
            </Typography.Link>
          </div>
        );
      },
    },
  ];
  const cancel = () => {
    setEditingKey("");
  };
  const edit = (record) => {
    setRowData(record);
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.ID);
  };
  const compareObjects = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (
      keys1.length !== keys2.length ||
      !keys1.every((key) => keys2.includes(key))
    ) {
      return false;
    }
    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  };
  const compareLists = (rowData, currentRowData) => {
    if (typeof rowData !== "object" || typeof currentRowData !== "object") {
      return false;
    }
    const result = compareObjects(rowData, currentRowData);
    return result;
  };
  function formatDateToYYYYMMDD(date) {
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const editTableRowData = async (props) => {
    try {
      const currentRowData = await form.getFieldValue();
      const comparision = compareLists(rowData, currentRowData);
      if (comparision === false) {
        const data = {
          id: currentRowData.ID,
          vms: "",
          name: currentRowData.Name,
          weekend_Date: currentRowData.Weekend_Date,
          client_Name: currentRowData.Client_Name,
          portal_Name: currentRowData.Portal_Name,
          uniqueExpId: currentRowData.UniqueExpId,
          amount : currentRowData.Amount,
          approved_Status: currentRowData.Approved_Status,
          fileNo : currentRowData.FileNo,
          otherExpId : currentRowData.OtherExpId,
          ProcessedDate : currentRowData.ProcessedDate,
          glAmount : currentRowData.GLAmount,
          glName : currentRowData.GLName,
          downloadDate: "2024-07-29T13:24:09.656Z",
        };
        const updateresponse = await updateExpensesMFRow(data);
        if (updateresponse.data.statusCode === 200) {
          const res = await getExpensesMfData();
          if (res !== null && res.length > 0) {
            setGriddata(res);
          }
          SuccessMessage(updateresponse.data.message);
        } else if (updateresponse.data.statusCode === 500) {
          InfoMessage(updateresponse.data.message);
        } else {
          ErrorMessage("Cannot able to update, please try again");
        }
        setEditingKey("");
      } else {
        InfoMessage("No changes made. Edit and try again.");
      }
    } catch (err) {
      return err;
    }
  };
  const downloadExpensesMSfile = async () => {
    try {
      const resp = await downloadExpensesMSXL(griddata);
      if (resp === "downloaded") {
        SuccessMessage("Downloaded successfully !!");
      }
    } catch {
      ErrorMessage("Cannot able to download, please try again");
    }
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const refreshDataMethod = async () => {
    try {
      setSyncSpin(true);
      setTableLoader(true);
      const res = await refreshExpensesData();
      if (res !== null && res.length > 0) {
        setGriddata(res);
      }
      setSyncSpin(false);
      setTableLoader(false);
    } catch {
      setSyncSpin(false);
      setTableLoader(false);
    }
  };
  
  const changeFromDate = (e) => {
    let sample = new Date(e);
    if (e !== null) {
      setFromDate(sample);
    } else {
      setFromDate();
    }
  
  
  
    // Format date as MM/DD/YYYY
    let newD = `${String(sample.getMonth() + 1).padStart(2, '0')}/${String(sample.getDate()).padStart(2, '0')}/${sample.getFullYear()}`;
    setNewFrom(newD);
  
    if (toDate !== undefined && sample < toDate && e !== null) {
  
      callConsolidatedApi(newD, newTo);
    } else if (toDate !== undefined && sample > toDate && e !== null) {
      InfoMessage("From date should not be greater than To date");
    }
  };
  
  const changeToDate = (e) => {
    let sample = new Date(e);
    if (e !== null) {
      setTodate(sample);
    } else {
      setTodate();
    }
   
    // Format date as MM/DD/YYYY
    let newD = `${String(sample.getMonth() + 1).padStart(2, '0')}/${String(sample.getDate()).padStart(2, '0')}/${sample.getFullYear()}`;
    setNewTo(newD);
  
    if (fromDate !== undefined && fromDate < sample && e !== null) {
     
      callConsolidatedApi(newFrom, newD);
    } else if (fromDate !== undefined && fromDate > sample && e !== null) {
      InfoMessage("To date should be greater than From date");
    }
  };
  const callConsolidatedApi = async (from, to) => {
    try {
      setTableLoader(true);
  
      const res = await getBillingMasterfilePayDateData(from, to);
  
      if (res && res.length > 0) {
        // Format the weekend date before setting grid data
        const formattedData = res.map((item) => ({
          ...item,
          Weekend_Date: item.Weekend_Date
            ? new Date(item.Weekend_Date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })
            : null, 
        }));
  
        setGriddata([...formattedData]); 
      } else {
        setGriddata([]); 
      }
  
      setTableLoader(false);
    } catch (error) {
      ErrorMessage("Cannot fetch data, please try again");
      setTableLoader(false);
    }
  };
  
  

 
  return (
    <>
      <div style={{ margin: 20 }}>
        <div style={{ marginBottom: 10 }} className="billingmf-div">
          <div style={{ width: "90%", display: "flex" }}>
            <Input
              placeholder="Search Portal Name \ Client Name"
              className="MFbilling-searchrow"
              // style={{ borderColor: "#3B52DF", color: "#3B52DF" }}
              onChange={(e) => setSearchRow(e.target.value)}
              allowClear
              suffix={
                <SearchOutlined
                  style={{ color: "#7185FF", justifyContent: "space-between" }}
                />
              }
            />
            <div className="refresh-class">
              {syncSpin ? (
                <Spin
                  indicator={
                    <ReloadOutlined
                      style={{ fontSize: 30, marginLeft: 10, color: "#3B52DF" }}
                      spin
                    />
                  }
                />
              ) : (
                <Tooltip
                  title={
                    <span
                      className="placeholder-span"
                      style={{ color: "#ffff" }}
                    >
                      Refresh data
                    </span>
                  }
                  color={"#108ee9"}
                  key={"#108ee9"}
                >
                  <ReloadOutlined
                    style={{
                      fontSize: 30,
                      marginLeft: 10,
                      color: "#3B52DF",
                      cursor: "pointer",
                    }}
                    onClick={refreshDataMethod}
                  />
                </Tooltip>
              )}
            </div>
           
        {/* { <div className="activeupload-class" style={{ height: 40 }}>
          <Upload.Dragger
            name="file"
           customRequest={handleActivelistUpload}
            // itemRender={itemActiveListRender}
            // fileList={activeList}
            accept=".xls,.xlsx"
            // onRemove={() => setActiveList([])}
            style={{
              // border: "1px solid rgba(0, 39, 102, 0.5)",
              // boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              border:"1px dashed #3B52DF",
              borderRadius: 10,
              marginTop:"5px",
              height: "40px",
              marginLeft:"20px",
              color:"#002766",
              width:"300px"
            }}
          > */}
          
          {/* <div className="content-file" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ color: "#3B52DF",marginLeft:"30px" }}>Upload Excel File</span>
        <UploadOutlined
          style={{
            color: "#3B52DF",
            fontSize: 17,
            marginLeft: "10px",
          }}
        />
      </div>
      {activitySpin && (
        <div className="xxl-spinner" style={{ marginLeft: "10px",marginRight:"10px" }}>
          <Spin size="medium" />
        </div>
      )}
    </div> */}
            
          {/* </Upload.Dragger> */}
          
          {/* <p style={{marginLeft:"25px",fontSize:"14px",fontFamily:"open sans",color:"#7185FF",width:"500px"}}> 
            Last Uploaded Date:{" "}
            {dateList &&
              dateList.HealthInsurancepaychexDate &&
              moment.utc(dateList.HealthInsurancepaychexDate).tz('Asia/Kolkata').format(
                "MM/DD/YYYY HH:mm:ss"
              )}
          </p>  */}
{/*           
        </div> } */}
        {/* <div className="p-4">
          <input type="file" accept=".zip"  onChange={handleActivelistUpload}></input>
        </div> */}
      
      </div>
    
           
     
            {/* <DatePicker
              className="msf-datepickers"
              onChange={changeFromDate}
              placeholder="From Date"
              format={"MM-DD-YYYY"}
            />
            <DatePicker
              className="msf-datepickers"
              onChange={changeToDate}
              placeholder="To Date"
              format={"MM-DD-YYYY"}
            /> */}

          <div style={{ display: "flex", alignItems: "center" }}>
            <Button onClick={downloadExpensesMSfile} className="dwld-invoice">
              Download .CSV
            </Button>
          </div> 
        </div>
        <div
          className={
            griddata.length > 0 ? "billing-table-class" : "billing-empty-table"
          }
        >
          {tableLoader ? (
            <Spin tip="Loading...">
             
              <Form form={form} component={false}>
                <Table
                  className="ten99-table"
                  rowClassName="editable-row"
                  columns={mergedColumns}
                  dataSource={griddata}
                  components={{ body: { cell: EditableCell } }}
                  bordered
                  scroll={{ x: "max-content", y: 400 }}
                  // pagination
                />{" "}
              </Form>{" "}
            </Spin>
          ) : griddata.length > 0 ? (
            <Form form={form} component={false}>
              <Table
                className="ten99-table"
                rowClassName="editable-row"
                columns={mergedColumns}
                dataSource={griddata}
                components={{ body: { cell: EditableCell } }}
                bordered
                scroll={{ x: 1500, y: 400 }}
              />
            </Form>
          ) : (
            <Form form={form} component={false}>
              <Table
                className="ten99-table"
                rowClassName="editable-row"
                columns={mergedColumns}
                dataSource={griddata}
                components={{ body: { cell: EditableCell } }}
                bordered
                scroll={{ x: 400, y: 400 }}
              />
            </Form>
          )}
        </div>
      </div>
    </>
  );
};
export default ExpensesMfTable;
